export default __webpack_public_path__ + "static/media/1826.fb477087.png";